import {useEffect, useState} from 'react';

import Header from '../../layouts/Header';
import Loading from "../../modules/generic/Loading";
import Image from "../../resources/images/dashboard.jpg"


const DashboardSection = (props) => {
    const [loading, setLoading] = useState(false)

    if (window.localStorage._tkn == null) {
        window.location.href = `${process.env.REACT_APP_BASE_URL}/auth/login`
    }

    useEffect(() => {

    }, [])


    return (
        <div className="DashboardSection">
            {loading && <Loading/>}
            <Header {...props} />
            <img src={Image} alt="dashboard" className="dashboard"/>
        </div>
    )
}

export default DashboardSection;